var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.275 1.66675H7.72501V5.30008H12.275V1.66675Z",
    fill: "#5DCCC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.525 1.66675V5.30008H18.225C17.8 3.00841 16.1083 1.67508 13.525 1.66675Z",
    fill: "#5DCCC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 6.55005V13.4917C1.66666 16.525 3.47499 18.3334 6.50832 18.3334H13.4917C16.525 18.3334 18.3333 16.525 18.3333 13.4917V6.55005H1.66666ZM12.0333 13.4834L10.3 14.4834C9.93332 14.6917 9.57499 14.8 9.24166 14.8C8.99166 14.8 8.76666 14.7417 8.55832 14.625C8.07499 14.35 7.80832 13.7834 7.80832 13.05V11.05C7.80832 10.3167 8.07499 9.75005 8.55832 9.47505C9.04166 9.19172 9.65832 9.24172 10.3 9.61672L12.0333 10.6167C12.675 10.9834 13.025 11.5 13.025 12.0584C13.025 12.6167 12.6667 13.1084 12.0333 13.4834Z",
    fill: "#5DCCC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47499 1.66675C3.89166 1.67508 2.19999 3.00841 1.77499 5.30008H6.47499V1.66675Z",
    fill: "#5DCCC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.bbcebdee2753eec5be341544117b9ee1.svg";
export { ForwardRef as ReactComponent };